import { render } from "./UploadFiles.vue?vue&type=template&id=1e2ad32a&scoped=true"
import script from "./UploadFiles.vue?vue&type=script&lang=js"
export * from "./UploadFiles.vue?vue&type=script&lang=js"

import "./UploadFiles.vue?vue&type=style&index=0&id=1e2ad32a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2ad32a"],['__file',"src/components/ui/UploadFiles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e2ad32a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e2ad32a', __exports__)) {
    api.reload('1e2ad32a', __exports__)
  }
  
  module.hot.accept("./UploadFiles.vue?vue&type=template&id=1e2ad32a&scoped=true", () => {
    api.rerender('1e2ad32a', render)
  })

}


export default __exports__